"use client";

import { c as _c } from "react/compiler-runtime";
import { useEvmSignFunction } from "../arch/evm/useEvmSignFunction";
import { useSvmSignFunction } from "../arch/svm/useSvmSignFunction";
export const useSignWithConnector = () => {
  const $ = _c(3);
  const evmSign = useEvmSignFunction();
  const svmSign = useSvmSignFunction();
  let t0;
  if ($[0] !== evmSign || $[1] !== svmSign) {
    t0 = async t1 => {
      const {
        connector,
        message,
        address
      } = t1;
      if (!connector.baseConnector.connected) {
        await connector.baseConnector.connect();
      }
      switch (connector.chainArch) {
        case "EVM":
          {
            return evmSign({
              connector,
              message,
              address
            });
          }
        case "SVM":
          {
            return svmSign({
              connector,
              message,
              address
            });
          }
      }
    };
    $[0] = evmSign;
    $[1] = svmSign;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};